import { api } from './api.ts';
import type { MePayload } from '../../shared/api.ts';

/**
 * Who is signed in, fetched once per page load.
 *
 * Cached as the promise, the same shape `stagingEnv` uses: the header remounts
 * on every navigation between Decks, Library and the Guide, and none of those
 * is a reason to ask the server again.
 *
 * FAILS SOFT to null. Every caller renders an avatar or a menu, and a studio
 * that cannot answer this should show a signed-in person no name rather than
 * an error where their face goes. The session itself is gated by `requireAuth`
 * on the routes that matter, never by this.
 */
let cached: Promise<MePayload | null> | null = null;

export function currentUser(): Promise<MePayload | null> {
  if (!cached) cached = api.get<MePayload>('/api/me').catch(() => null);
  return cached;
}

/** Drop the cache. Signing out and back in as somebody else must not leave the
 *  first person's face in the corner. */
export function forgetUser(): void {
  cached = null;
}
